import { render, staticRenderFns } from "./SetAntiLeechDialog.vue?vue&type=template&id=a57d6378&"
import script from "./SetAntiLeechDialog.vue?vue&type=script&lang=js&"
export * from "./SetAntiLeechDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports